(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ia-apres-gel-couleur"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const root = document.getElementById('ia-gc');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const native = document.getElementById('ia-apres-other-products');
    const words = JSON.parse(root.querySelector('.ia-gc-i18n').textContent);
    const photoMap = JSON.parse(root.querySelector('.ia-gc-photos').textContent);
    const colors = [...root.querySelectorAll('.ia-gc-data')].flatMap(node => JSON.parse(node.textContent)).map(color => ({...color, ...photoMap[color.code]}));
    if (!colors.length) return;
    const panel = root.querySelector('#ia-gc-panel');
    const grid = root.querySelector('.ia-gc-grid');
    const query = root.querySelector('#ia-gc-query');
    const counter = root.querySelector('.ia-gc-count');
    const sort = root.querySelector('#ia-gc-sort');
    const pages = root.querySelector('.ia-gc-pages');
    const dialog = root.querySelector('dialog');
    const params = new URL(location.href).searchParams;
    let page = 1;
    let selectedColor;
    let display = params.get('apres_view') === 'bottles' ? 'bottles' : 'chart';
    let range = params.get('apres_range') || 'all';
    let view = params.get('apres') === 'all' ? 'all' : 'colors';
    if (![...root.querySelectorAll('[data-range]')].some(button => button.dataset.range === range)) range = 'all';
    query.value = params.get('apres_q') || '';
    sort.value = params.get('apres_sort') === 'name' ? 'name' : 'number';
    const normalized = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '');
    const setURL = () => {
      const url = new URL(location.href);
      url.searchParams.set('apres', view === 'all' ? 'all' : 'gel-couleur');
      if (query.value) url.searchParams.set('apres_q', query.value); else url.searchParams.delete('apres_q');
      if (range !== 'all') url.searchParams.set('apres_range', range); else url.searchParams.delete('apres_range');
      if (sort.value === 'name') url.searchParams.set('apres_sort', 'name'); else url.searchParams.delete('apres_sort');
      if (display === 'bottles') url.searchParams.set('apres_view', 'bottles'); else url.searchParams.delete('apres_view');
      history.replaceState(null, '', url);
    };
    const setView = () => {
      panel.hidden = view !== 'colors';
      if (native) native.hidden = view === 'colors';
      root.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
    };
    const photoURL = (url, width) => {
      const result = new URL(url, location.href);
      result.searchParams.set('width', String(width));
      return result.href;
    };
    const setPhoto = kind => {
      const original = kind === 'bottle' ? selectedColor.image : selectedColor[kind];
      const photo = root.querySelector('.ia-gc-detail-image');
      photo.src = photoURL(original || selectedColor.image, 900);
      photo.alt = `${selectedColor.code} · ${selectedColor.name} — ${words[kind]}`;
      root.querySelector('.ia-gc-enlarge').href = original || selectedColor.image;
      root.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.photo === kind)));
    };
    const openColor = color => {
      selectedColor = color;
      root.querySelector('[data-photo="swatch"]').hidden = !color.swatch;
      root.querySelector('[data-photo="nails"]').hidden = !color.nails;
      setPhoto(display === 'chart' && color.swatch ? 'swatch' : 'bottle');
      root.querySelector('.ia-gc-detail-code').textContent = `Gel Couleur · ${color.code}`;
      root.querySelector('#ia-gc-dialog-title').textContent = color.name;
      root.querySelector('.ia-gc-detail-price').textContent = color.money;
      root.querySelector('.ia-gc-finish').textContent = color.group === 'Jellies' ? words.jelly_finish : color.group === 'Glitters' ? words.glitter_finish : words.finish;
      const shop = root.querySelector('.ia-gc-shop');
      shop.hidden = !color.live && !color.preview;
      shop.href = color.live ? color.url : (color.preview || '#');
      shop.textContent = color.live ? (color.available ? words.shop : words.view_product) : words.preview_product;
      if (!color.live) { shop.target = '_blank'; shop.rel = 'noopener'; } else { shop.removeAttribute('target'); shop.removeAttribute('rel'); }
      root.querySelector('.ia-gc-draft').hidden = color.live;
      dialog.showModal();
    };
    const render = () => {
      const term = normalized(query.value);
      const filtered = colors.filter(color => (range === 'all' || color.group === range) && (!term || normalized(`${color.code} ${color.name}`).includes(term)));
      const groupOrder = ['201–250','251–300','301–350','351–364','Nudes','Jellies','Glitters'];
      filtered.sort((a,b) => sort.value === 'name' ? a.name.localeCompare(b.name,'en',{sensitivity:'base'}) : groupOrder.indexOf(a.group)-groupOrder.indexOf(b.group) || a.code.localeCompare(b.code,'en',{numeric:true}));
      const pageSize = display === 'chart' ? Math.max(1, filtered.length) : 24;
      const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
      root.dataset.display = display;
      root.querySelectorAll('[data-display]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.display === display)));
      page = Math.min(page, totalPages);
      const start = (page - 1) * pageSize;
      grid.replaceChildren();
      filtered.slice(start, start + pageSize).forEach(color => {
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ia-gc-card';
        button.dataset.code = color.code;
        const img = document.createElement('img');
        img.src = photoURL(display === 'chart' && color.swatch ? color.swatch : color.image, display === 'chart' ? 240 : 480);
        img.alt = `${color.code} · ${color.name} — ${display === 'chart' ? words.swatch : words.bottle}`;
        img.decoding = 'async';
        img.loading = 'lazy';
        img.width = 360;
        img.height = 360;
        button.append(img);
        for (const [className, text] of [['ia-gc-code', color.code], ['ia-gc-name', color.name], ['ia-gc-price', color.money], ['ia-gc-open-label', words.view_color]]) {
          const span = document.createElement('span');
          span.className = className;
          span.textContent = text;
          button.append(span);
        }
        button.addEventListener('click', () => openColor(color));
        item.append(button);
        grid.append(item);
      });
      counter.textContent = words.results.replace('[start]', filtered.length ? start + 1 : 0).replace('[end]', Math.min(start + pageSize, filtered.length)).replace('[count]', filtered.length);
      root.querySelector('.ia-gc-empty').hidden = filtered.length !== 0;
      pages.hidden = totalPages <= 1;
      root.querySelector('.ia-gc-page-number').textContent = `${page} / ${totalPages}`;
      root.querySelector('[data-page="prev"]').disabled = page === 1;
      root.querySelector('[data-page="next"]').disabled = page === totalPages;
      root.querySelectorAll('[data-range]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.range === range)));
    };
    root.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => { view = button.dataset.view; setView(); setURL(); }));
    root.querySelectorAll('[data-range]').forEach(button => button.addEventListener('click', () => { range = button.dataset.range; page = 1; render(); setURL(); }));
    root.querySelectorAll('[data-display]').forEach(button => button.addEventListener('click', () => { display = button.dataset.display; page = 1; render(); setURL(); }));
    root.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => setPhoto(button.dataset.photo)));
    query.addEventListener('input', () => { page = 1; render(); setURL(); });
    sort.addEventListener('change', () => { page = 1; render(); setURL(); });
    root.querySelectorAll('[data-page]').forEach(button => button.addEventListener('click', () => { page += button.dataset.page === 'next' ? 1 : -1; render(); counter.scrollIntoView({block:'start'}); }));
    root.querySelector('.ia-gc-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    root.hidden = false;
    render();
    setView();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-apres-pairings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ia-apres-extras')) {
    class ApresExtras extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-apres-card]'));
        this.status = this.querySelector('[data-extras-status]');
        this.bulk = this.querySelector('[data-add-selected]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
        this.dataset.ready = '';
        this.querySelector('[data-extras-footer]').hidden = false;
        this.addEventListener('change', event => {
          const card = event.target.closest('[data-apres-card]');
          if (card && event.target.matches('[data-extra-variant]')) this.updateCard(card);
          this.updateTotal();
        });
        this.addEventListener('input', () => this.updateTotal());
        this.addEventListener('submit', event => {
          const card = event.target.closest('[data-apres-card]');
          if (!card) return;
          event.preventDefault();
          this.addCards([card], event.submitter);
        });
        this.bulk.addEventListener('click', () => this.addCards(this.selectedCards(), this.bulk));
        this.cards.forEach(card => this.updateCard(card));
        this.updateTotal();
      }
      selectedCards() {
        return this.cards.filter(card => card.querySelector('[data-extra-pick]').checked);
      }
      updateCard(card) {
        const option = card.querySelector('[data-extra-variant]').selectedOptions[0];
        card.querySelector('[data-extra-price]').textContent = option.dataset.money;
        const image = card.querySelector('img');
        if (image && option.dataset.photo) {
          image.removeAttribute('srcset');
          image.src = option.dataset.photo;
        }
        card.querySelectorAll('[data-extra-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', option.value);
          link.href = url.href;
        });
      }
      updateTotal() {
        const selected = this.selectedCards();
        let total = 0;
        let count = 0;
        let valid = true;
        selected.forEach(card => {
          const input = card.querySelector('[data-extra-quantity]');
          const quantity = Number(input.value);
          if (!input.checkValidity() || !Number.isSafeInteger(quantity) || quantity < 1) valid = false;
          else {
            total += Number(card.querySelector('[data-extra-variant]').selectedOptions[0].dataset.cents) * quantity;
            count += quantity;
          }
        });
        this.querySelector('[data-extras-total]').textContent = this.formatter.format(total / 100);
        this.querySelector('[data-extras-count]').textContent = '(' + count + ')';
        this.bulk.disabled = this.busy || !selected.length || !valid;
      }
      async addCards(cards, trigger) {
        if (this.busy || !cards.length) return;
        for (const card of cards) {
          if (!card.reportValidity()) return;
        }
        const items = cards.map(card => ({id:card.querySelector('[data-extra-variant]').value, quantity:Number(card.querySelector('[data-extra-quantity]').value)}));
        if (items.some(item => !Number.isSafeInteger(item.quantity) || item.quantity < 1)) return;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        this.querySelectorAll('button').forEach(button => button.disabled = true);
        this.status.textContent = '';
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {bubbles:true, detail:{sections}}));
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items, sections:sections.slice(0,5), sections_url:location.pathname})});
          const added = await response.json();
          if (!response.ok || added.status) throw new Error(added.description || this.dataset.error);
          this.status.textContent = this.dataset.success;
          this.querySelector('[data-extras-cart]').hidden = false;
          cards.forEach(card => card.querySelector('[data-extra-pick]').checked = false);
          try {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers:{'Accept':'application/json'}});
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            const cart = await cartResponse.json();
            cart.sections = added.sections;
            if (typeof FoxTheme !== 'undefined' && FoxTheme.pubsub) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart});
              document.dispatchEvent(new CustomEvent('product-ajax:added', {detail:{product:added}}));
              const drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function' && FoxTheme.settings.cartType !== 'page') drawer.show(trigger);
            }
          } catch (refreshError) {
            this.querySelector('[data-extras-cart]').focus();
          }
        } catch (error) {
          this.status.textContent = error.message || this.dataset.error;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.querySelectorAll('button').forEach(button => button.disabled = false);
          this.updateTotal();
        }
      }
    }
    customElements.define('ia-apres-extras', ApresExtras);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-brand-banners"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ia-brand-banners')){
  customElements.define('ia-brand-banners',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const track=this.querySelector('.ia-brands__track');
      const buttons=this.querySelectorAll('[data-direction]');
      const update=()=>{buttons[0].disabled=track.scrollLeft<3;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const card=track.querySelector('.ia-brands__card');
        const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left:Number(button.dataset.direction)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update);
      this.observer.observe(track);
      update();
      this.querySelectorAll('.ia-brands__media').forEach(details=>{
        details.addEventListener('toggle',()=>{
          const current=details.querySelector('img');
          if(details.open&&!current)details.append(details.querySelector('template').content.cloneNode(true));
          if(!details.open&&current)current.remove();
        });
      });
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-compact-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.ia-premium-header').forEach(header => {
      const toggle = header.querySelector('.ia-compact-menu');
      const nav = header.querySelector('.header__navigation');
      if (!toggle || !nav || header.dataset.iaCompactReady) return;
      header.dataset.iaCompactReady = 'true';
      if (!nav.id) nav.id = `ia-compact-navigation-${header.dataset.sectionId}`;
      toggle.setAttribute('aria-controls', nav.id);
      const desktop = window.matchMedia('(min-width:1024px)');
      let frame = 0;
      const close = () => {
        nav.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        header.classList.remove('ia-header-nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      };
      const update = () => {
        frame = 0;
        const compact = header.classList.contains('ia-header-compact');
        const shouldCompact = desktop.matches && (compact ? window.scrollY > 32 : window.scrollY > 160);
        if (shouldCompact === compact) return;
        if (shouldCompact && nav.contains(document.activeElement)) return;
        if (shouldCompact && nav.querySelector('details[open]')) return;
        if (!shouldCompact && document.activeElement === toggle) header.querySelector('.header__logo a')?.focus({preventScroll:true});
        close();
        header.classList.toggle('ia-header-compact', shouldCompact);
        header.setHeight?.();
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      toggle.addEventListener('click', () => {
        const open = !header.classList.contains('ia-header-nav-open');
        if (!open) close();
        header.classList.toggle('ia-header-nav-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        header.setHeight?.();
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !header.classList.contains('ia-header-nav-open')) return;
        if (nav.querySelector('details[open]')) return;
        close();
        toggle.focus();
        header.setHeight?.();
      });
      header.addEventListener('focusout', schedule);
      window.addEventListener('scroll', schedule, {passive:true});
      desktop.addEventListener('change', schedule);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-essie-picker"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ia-essie-picker'))customElements.define('ia-essie-picker',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('[data-color-search]');input.addEventListener('change',e=>e.stopPropagation());input.addEventListener('input',()=>{const q=input.value.trim().toLowerCase();let count=0;for(const option of this.querySelectorAll('option')){const match=option.textContent.toLowerCase().includes(q);option.hidden=!match&&!option.selected;if(match)count++;}this.querySelector('[data-empty]').hidden=count!==0;});}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-fall-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
 const trigger=event.target.closest('[data-fall-open]');
 if(trigger){const dialog=document.getElementById(trigger.dataset.fallOpen);if(dialog&&!dialog.open)dialog.showModal();}
 const dialog=event.target;
 if(dialog instanceof HTMLDialogElement&&dialog.classList.contains('ia-fall-dialog')){
 const rect=dialog.getBoundingClientRect();
 if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-gold-media-panel"] && !Shopify.designMode) return;
  try {
    (function(){
 const arrange=()=>document.querySelectorAll('product-info[data-product-id="9237953511709"]').forEach(root=>{
  const panel=root.querySelector('.ia-gold-media-panel'),gallery=root.querySelector('.ia-gold-gallery'),shop=root.querySelector('.ia-gold-shop');
  if(!panel||!gallery||!shop)return;
  if(window.matchMedia('(max-width:767px)').matches){if(panel.nextElementSibling!==shop)shop.before(panel)}
  else if(panel.parentElement!==gallery)gallery.append(panel);
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arrange);else arrange();
 window.matchMedia('(max-width:767px)').addEventListener('change',arrange);
 document.addEventListener('shopify:section:load',arrange);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-gold-product-photos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    const input = event.target;
    if (!input.matches('variant-selects input[type="radio"], variant-selects select')) return;
    const scope = input.closest('product-info');
    const panel = scope?.querySelector('[data-gold-main-photo]');
    if (!panel) return;
    const refill = String(input.value).includes('1000ml');
    const url = refill ? panel.dataset.refill : panel.dataset.small;
    const img = panel.querySelector('[data-gold-main-img]');
    if (url) img.src = url;
    img.hidden = !url;
    panel.querySelector('[data-gold-main-pending]').hidden = !!url;
    panel.querySelector('[data-gold-main-caption]').textContent = refill ? panel.dataset.refillLabel : panel.dataset.smallLabel;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-gold-spa-collection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-gold-size]')) return;
    const select = event.target;
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    const button = form.querySelector('[data-gold-add]');
    form.querySelector('[data-gold-price]').textContent = option.dataset.price;
    const card = form.closest('.ia-gold-shop__card');
    const photo = card.querySelector('[data-gold-card-image]');
    if (option.dataset.image) photo.src = option.dataset.image;
    photo.hidden = !option.dataset.image;
    card.querySelector('[data-gold-card-pending]').hidden = !!option.dataset.image;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-keyano-shopping"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-keyano-shop]').forEach(root=>{const scent=root.querySelector('[data-ks-scent]');const kind=root.querySelector('[data-ks-kind]');const cards=[...root.querySelectorAll('[data-ks-card]')];const status=root.querySelector('[data-ks-status]');const empty=root.querySelector('[data-ks-empty]');scent.value='cranberry';function update(){let count=0;cards.forEach(card=>{const show=(scent.value==='all'||card.dataset.scent===scent.value)&&(kind.value==='all'||card.dataset.kind===kind.value);card.hidden=!show;if(show)count++});status.textContent=scent.options[scent.selectedIndex].text+' · '+count+' / '+cards.length;empty.hidden=count>0} scent.addEventListener('change',update);kind.addEventListener('change',update);update()});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-opi-catalog"] && !Shopify.designMode) return;
  try {
    class OpiQuickCatalog extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.items = JSON.parse(this.querySelector('[data-opi-items]').textContent);
    this.meta = JSON.parse(this.querySelector('[data-opi-meta]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-opi-labels]').textContent);
    this.currency = this.dataset.currency || 'USD';
    this.selected = new Map();
    this.quantities = new Map();
    this.tab = new URL(location.href).searchParams.get('opi') || 'NL';
    if (!['NL','GC','DP','matching','new','best','essentials'].includes(this.tab)) this.tab = 'NL';
    this.collection = new URL(location.href).searchParams.get('collection') || 'mm2026';
    if (!['mm2026','spring2026','fall2026','summer2026','all','bubble'].includes(this.collection)) this.collection='mm2026';
    this.collectionView='sets';
    this.limit = 36;
    this.items = this.items.map(p => ({...p, ...this.meta[p.sku]}));
    if (this.dataset.preview === 'true') {
      const reviewItems = [...this.querySelectorAll('[data-opi-preview-items]')].flatMap(el => JSON.parse(el.textContent));
      this.items = reviewItems;
      this.currency = 'USD';
    }
    try {
      const response = await fetch(this.dataset.swatchMap);
      if (response.ok) { const swatches = await response.json(); this.items = this.items.map(p => ({...p, swatch: swatches[p.sku]?.swatch || swatches[p.sku]?.mani, mani: swatches[p.sku]?.mani})); }
    } catch {}
    this.focusId = null;
    this.addEventListener('click', event => {
      const tile = event.target.closest('[data-opi-focus-id]');
      if (tile) { event.preventDefault(); this.focusId=tile.dataset.opiFocusId; this.updateFocus(); this.querySelector('[data-opi-focus]').scrollIntoView({behavior:'smooth',block:'start'}); }
      const control=event.target.closest('button');
      if(!control || control.disabled)return;
      if(control.hasAttribute('data-focus-prev') || control.hasAttribute('data-focus-next')){
        const index=this.focusItems.findIndex(p=>String(p.id)===this.focusId);
        const next=index+(control.hasAttribute('data-focus-next')?1:-1);
        if(this.focusItems[next]){this.focusId=String(this.focusItems[next].id);this.updateFocus();}
      }
      if(control.hasAttribute('data-focus-add')){
        const input=this.querySelector('[data-focus-qty]');
        if(input.reportValidity()){this.quantities.set(this.focusId,Number(input.value));this.add([{id:this.focusId,quantity:Number(input.value)}]);}
      }
    });
    this.querySelector('[data-focus-qty]').addEventListener('input',event=>{
      if(event.target.validity.valid)this.quantities.set(this.focusId,Number(event.target.value));
    });
    this.byId = new Map(this.items.map(p => [String(p.id), p]));
    this.querySelector('[data-opi-search]').addEventListener('input', () => { this.limit=36; this.render(); });
    for (const el of this.querySelectorAll('[data-opi-sort],[data-opi-filter]')) el.addEventListener('change', () => { this.limit=36; this.render(); });
    this.addEventListener('click', e => {
      const button=e.target.closest('button'); if (!button || button.disabled) return;
      if (button.dataset.opiTab) { this.tab=button.dataset.opiTab; this.limit=36; this.querySelector('[data-opi-filter]').value='all'; const next=new URL(location.href); next.searchParams.set('opi',this.tab); history.replaceState(null,'',next); this.render(); }
      if (button.dataset.opiCollection) { this.collection=button.dataset.opiCollection; this.collectionView='sets'; this.limit=36; this.querySelector('[data-opi-filter]').value='all'; this.querySelector('[data-opi-search]').value=''; const next=new URL(location.href); next.searchParams.set('opi','new'); next.searchParams.set('collection',this.collection); history.replaceState(null,'',next); this.render(); }
      if (button.dataset.opiView) { this.collectionView=button.dataset.opiView; this.limit=36; this.querySelector('[data-opi-filter]').value='all'; this.querySelector('[data-opi-search]').value=''; this.render(); }
      if (button.dataset.opiGalleryPhoto) { const dialog=this.querySelector('[data-opi-lightbox]'); dialog.querySelector('img').src=button.dataset.opiGalleryPhoto; dialog.querySelector('img').alt=button.querySelector('img').alt; dialog.showModal(); }
      if (button.hasAttribute('data-opi-gallery-close')) this.querySelector('[data-opi-lightbox]').close();
      if (button.hasAttribute('data-opi-more')) { this.limit+=36; this.render(); }
      if (button.dataset.opiAdd) this.add([{id:button.dataset.opiAdd,quantity:this.quantity(button.dataset.opiAdd)}]);
      if (button.hasAttribute('data-opi-add-selected')) this.add([...this.selected].map(([id,quantity]) => ({id,quantity})));
      if (button.hasAttribute('data-opi-clear')) { this.selected.clear(); this.render(); }
    });
    this.addEventListener('input', e => {
      const id=e.target.dataset.opiQuantity; if (!id) return;
      const value=Number(e.target.value);
      if (!Number.isInteger(value) || value<1 || value>999) { e.target.setCustomValidity(this.labels.quantity_error); return; }
      e.target.setCustomValidity(''); this.quantities.set(id,value);
      if (this.selected.has(id)) this.selected.set(id,value);
      this.summary();
    });
    this.addEventListener('change', e => {
      const id=e.target.dataset.opiQuantity || e.target.dataset.opiSelect;
      if (!id) return;
      if (e.target.dataset.opiQuantity) {
        const value=Number(e.target.value);
        if (!Number.isInteger(value) || value<1 || value>999) { e.target.setCustomValidity(this.labels.quantity_error); e.target.reportValidity(); return; }
        e.target.setCustomValidity(''); this.quantities.set(id,value);
        if (this.selected.has(id)) this.selected.set(id,value);
      } else if (e.target.checked) this.selected.set(id,this.quantity(id));
      else this.selected.delete(id);
      this.summary();
    });
    this.render();
  }
  updateFocus() {
    const panel=this.querySelector('[data-opi-focus]');
    const p=this.focusItems?.find(p=>String(p.id)===this.focusId);
    panel.hidden=!p;
    if(!p)return;
    const swatch=panel.querySelector('[data-focus-swatch]'),bottle=panel.querySelector('[data-focus-bottle]');
    const src=p.swatch||p.image;
    if(src && swatch.getAttribute('src')!==src)swatch.src=src;
    swatch.hidden=!src;swatch.alt=p.name+' · '+p.code;
    if(p.image && bottle.getAttribute('src')!==p.image)bottle.src=p.image;
    bottle.hidden=!p.image || !p.swatch;bottle.alt=p.name+' · '+(this.labels['formula_'+p.formula]||p.formula);
    panel.querySelector('[data-focus-name]').textContent=p.name;
    panel.querySelector('[data-focus-code]').textContent=(this.labels['formula_'+p.formula]||p.formula)+' · '+p.code;
    panel.querySelector('[data-focus-price]').textContent=this.money(p.price)+' · '+(p.size||'');
    panel.querySelector('[data-focus-qty]').value=this.quantity(this.focusId);
    panel.querySelector('[data-focus-qty]').disabled=this.busy||!p.available;
    const index=this.focusItems.indexOf(p);
    panel.querySelector('[data-focus-prev]').disabled=index===0||this.busy;
    panel.querySelector('[data-focus-next]').disabled=index===this.focusItems.length-1||this.busy;
    const add=panel.querySelector('[data-focus-add]');
    add.disabled=this.busy||!p.available;add.textContent=p.available?this.labels.add:this.labels.sold_out;
    this.querySelectorAll('[data-opi-focus-id]').forEach(a=>a.setAttribute('aria-current',String(a.dataset.opiFocusId===this.focusId)));
  }
  quantity(id) { return this.quantities.get(String(id)) || 1; }
  money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.currency}).format(cents/100); }
  normalize(value) { return String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[’‘]/g,"'").toLowerCase(); }
  escape(value) { return String(value ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  matching(p,tab) {
    if (['NL','GC','DP'].includes(tab)) return p.formula===tab && p.kind==='color';
    if (tab==='matching') return p.kind==='matching';
    if (tab==='new') return (this.collection!=='fall2026' || !this.collectionView || (this.collectionView==='sets' ? p.kind==='seasonal_set' : p.kind==='color')) && Boolean(p.new) && (!this.collection || this.collection==='all' || (this.collection==='bubble' ? p.code==='S061' && p.collection==='spring2026' : p.collection===this.collection));
    if (tab==='best') return Boolean(p.best) && p.kind==='color';
    return p.kind==='essential' || p.formula==='IS';
  }
  render() {
    const e=v=>this.escape(v), l=this.labels;
    this.querySelectorAll('[data-opi-tab]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.opiTab===this.tab));});
    this.querySelector('[data-opi-collections]').hidden=this.tab!=='new';
    this.querySelectorAll('[data-opi-collection]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.opiCollection===this.collection)));
    this.querySelector('[data-opi-set-switch]').hidden=!(this.tab==='new' && this.collection==='fall2026');
    this.querySelectorAll('[data-opi-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.opiView===this.collectionView)));
    this.querySelector('[data-opi-gallery]').hidden=!(this.tab==='new' && this.collection==='mm2026');
    this.querySelector('[data-opi-grid]').classList.toggle('opi-grid--sets',this.tab==='new' && (this.collection==='mm2026' || (this.collection==='fall2026' && this.collectionView==='sets')));
    const query=this.normalize(this.querySelector('[data-opi-search]').value.trim());
    const filter=this.querySelector('[data-opi-filter]');
    const showFilter=['new','best','essentials'].includes(this.tab);
    filter.parentElement.hidden=!showFilter;
    for (const option of filter.options) option.hidden = option.value !== 'all' && (this.tab === 'essentials' ? ['NL','GC','DP'].includes(option.value) : ['base_top','care','prep','lamps'].includes(option.value));
    const filtered=this.items.filter(p=>this.matching(p,this.tab) && (!showFilter || filter.value==='all' || p.formula===filter.value || (p.kind==='essential' && p.group===filter.value)) && (!query || this.normalize([p.name,p.code,p.sku].join(' ')).includes(query)));
    const sort=this.querySelector('[data-opi-sort]').value;
    filtered.sort((a,b)=>(this.tab==='essentials' && filter.value==='all' && a.kind!==b.kind ? (a.kind==='essential'?-1:1) : 0) || (sort==='price'?a.price-b.price:sort==='code'?String(a.code||a.sku).localeCompare(String(b.code||b.sku),'en',{numeric:true})||String(a.code||a.sku).localeCompare(String(b.code||b.sku))||a.name.localeCompare(b.name):a.name.localeCompare(b.name,'en',{sensitivity:'base'})||a.formula.localeCompare(b.formula)));
    this.focusItems=filtered.filter(p=>p.kind==='color');
    if(!this.focusItems.some(p=>String(p.id)===this.focusId))this.focusId=String((this.focusItems.find(p=>p.code==='H19') || this.focusItems.find(p=>p.mani) || this.focusItems[0])?.id || '');
    this.updateFocus();
    this.querySelector('[data-opi-count]').textContent=l.count.replace('{shown}',Math.min(this.limit,filtered.length)).replace('{total}',filtered.length);
    this.querySelector('[data-opi-note]').textContent=this.tab==='new' && this.collection!=='all' ? l['note_'+this.collection] : l['note_'+this.tab];
    this.querySelector('[data-opi-grid]').innerHTML=filtered.slice(0,this.limit).map(p=>{
      const id=String(p.id), disabled=!p.available || this.busy;
      return `<article class="opi-card"><a class="opi-card__photo" ${p.kind==='color'?`data-opi-focus-id="${id}"`: ''} href="${e(p.url)}">${p.kind==='seasonal_set' && p.collection==='fall2026' ? `<span class="opi-set-montage">${this.items.filter(x=>x.collection==='fall2026' && x.formula===p.formula && x.kind==='color').sort((a,b)=>a.code.localeCompare(b.code)).map(x=>`<img src="${e(x.image)}" alt="${e(x.name+' · '+x.code)}" width="120" height="140" loading="lazy">`).join('')}</span>` : p.image && p.swatch ? `<span class="opi-photo-pair"><img src="${e(p.image)}" width="180" height="220" loading="lazy" decoding="async" alt="${e(p.name+' — '+p.code)}"><img class="opi-photo-swatch" src="${e(p.swatch)}" width="180" height="220" loading="lazy" decoding="async" alt="${e(p.name+' — '+p.code)}"></span>` : p.image?`<img src="${e(p.image)}" width="360" height="440" loading="lazy" decoding="async" alt="${e(p.name+' — '+(p.code||'')+' '+l['formula_'+p.formula])}">`:''}</a><div class="opi-card__body"><div class="opi-card__eyebrow">${e(l['formula_'+p.formula]||p.formula)} <span>${e(p.code||'')}</span></div><a class="opi-card__name" href="${e(p.url)}">${e(p.name)}</a><div class="opi-card__price">${e(this.money(p.price))}<small>${e(p.size||'')}</small></div><div class="opi-card__choose"><label><input type="checkbox" data-opi-select="${id}" ${this.selected.has(id)?'checked':''} ${disabled?'disabled':''}>${e(l.select)}</label><label class="opi-card__quantity">${e(l.qty)}<input type="number" min="1" max="999" step="1" value="${this.quantity(id)}" data-opi-quantity="${id}" aria-label="${e(l.qty+' — '+p.name)}" ${disabled?'disabled':''}></label></div><button class="opi-button opi-card__add" type="button" data-opi-add="${id}" ${disabled?'disabled':''}>${e(p.available?l.add:l.sold_out)}</button></div></article>`;
    }).join('');
    this.querySelector('[data-opi-empty]').hidden=filtered.length!==0;
    this.querySelector('[data-opi-more]').hidden=filtered.length<=this.limit;
    this.updateFocus();
    this.summary();
  }
  summary() {
    let count=0,total=0;
    for (const [id,quantity] of this.selected) { count+=quantity; total+=quantity*this.byId.get(id).price; }
    this.querySelector('[data-opi-selected-count]').textContent=this.labels.selected.replace('{colors}',this.selected.size).replace('{qty}',count)+' · '+this.money(total);
    this.querySelector('[data-opi-add-selected]').disabled=!this.selected.size || this.busy;
    this.querySelector('[data-opi-clear]').disabled=!this.selected.size || this.busy;
  }
  async add(items) {
    if (this.busy || !items.length) return;
    for (const item of items) {
      const input=this.querySelector(`[data-opi-quantity="${item.id}"]`);
      if (input && !input.reportValidity()) return;
      if (!this.byId.get(String(item.id))?.available || !Number.isInteger(item.quantity) || item.quantity<1) return;
    }
    const status=this.querySelector('[data-opi-status]');
    const focusStatus=this.querySelector('[data-focus-status]');
    if (this.dataset.preview==='true') { status.textContent=this.labels.preview_message; focusStatus.textContent=status.textContent; return; }
    this.busy=true; this.render(); status.textContent=this.labels.adding;
    try {
      const root=window.Shopify?.routes?.root || '/';
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items.map(i=>({id:Number(i.id),quantity:i.quantity})),sections:['cart-icon-bubble']})});
      const result=await response.json();
      if (!response.ok) throw new Error(result.description || result.message || this.labels.add_error);
      for (const item of items) this.selected.delete(String(item.id));
      if (result.sections?.['cart-icon-bubble']) {
        const parsed=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');
        const current=document.getElementById('cart-icon-bubble'), replacement=parsed.getElementById('cart-icon-bubble');
        if (current && replacement) current.innerHTML=replacement.innerHTML;
      }
      status.textContent=this.labels.added.replace('{qty}',items.reduce((n,i)=>n+i.quantity,0));
    } catch (error) { status.textContent=(error instanceof TypeError || error instanceof SyntaxError)?this.labels.network_error:error.message; }
    finally { this.busy=false; focusStatus.textContent=status.textContent; this.render(); }
  }
}
if (!customElements.get('opi-quick-catalog')) customElements.define('opi-quick-catalog',OpiQuickCatalog);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-opi-modern-picker"] && !Shopify.designMode) return;
  try {
    class OpiModernPicker extends HTMLElement {
  static states = new Map();
  static indexes = new Map();
  connectedCallback() {
    this.details=this.querySelector('details');this.search=this.querySelector('[data-search]');
    this.state=OpiModernPicker.states.get(this.dataset.key)||{open:false,query:'',scroll:0};
    this.details.open=this.state.open;this.search.value=this.state.query;
    this.querySelector('.ia-opi-mini-grid').scrollTop=this.state.scroll;
    this.details.addEventListener('toggle',()=>{this.state.open=this.details.open;this.save();if(this.details.open)this.loadIndex();});
    this.search.addEventListener('input',()=>{this.state.query=this.search.value;this.save();this.filter();});
    this.search.addEventListener('change',e=>e.stopPropagation());
    this.addEventListener('change',e=>{if(e.target.type==='radio'){this.state.scroll=this.querySelector('.ia-opi-mini-grid').scrollTop;this.save();}});
    if(this.details.open||this.state.query)this.loadIndex();
  }
  save(){OpiModernPicker.states.set(this.dataset.key,{...this.state});}
  async loadIndex(){
    const url=this.dataset.index;
    if(!OpiModernPicker.indexes.has(url))OpiModernPicker.indexes.set(url,fetch(url).then(r=>{if(!r.ok)throw Error();return r.json();}).catch(()=>null));
    this.items=await OpiModernPicker.indexes.get(url);if(this.isConnected)this.filter();
  }
  normalize(s){return s.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,'');}
  filter(){
    const q=this.normalize(this.search.value),results=this.querySelector('[data-search-results]'),local=this.querySelector('[data-local]'),empty=this.querySelector('[data-no-results]');
    results.replaceChildren();results.hidden=!q;local.hidden=!!q;empty.hidden=true;
    this.querySelectorAll('.ia-opi-mini-choice').forEach(el=>{el.hidden=false;});
    if(!q)return;
    if(!this.items){local.hidden=false;results.hidden=true;this.querySelectorAll('.ia-opi-mini-choice').forEach(el=>{el.hidden=!this.normalize(el.textContent).includes(q);});return;}
    this.querySelectorAll('.ia-opi-mini-choice').forEach(el=>{el.hidden=false;});
    const seen=new Set();const matches=this.items.filter(p=>p.formula===this.dataset.formula&&this.normalize(p.code+' '+p.name).includes(q)&&!seen.has(p.sku)&&seen.add(p.sku)).sort((a,b)=>Number(this.normalize(b.code)===q)-Number(this.normalize(a.code)===q));
    for(const p of matches){
      const a=document.createElement('a');a.href=p.url;
      if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.name;img.loading='lazy';a.append(img);}
      const text=document.createElement('span'),code=document.createElement('strong'),name=document.createElement('span');code.textContent=p.code;name.textContent=p.name;text.append(code,name);a.append(text);results.append(a);
    }
    empty.hidden=matches.length!==0;
  }
}
if(!customElements.get('opi-modern-picker'))customElements.define('opi-modern-picker',OpiModernPicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-opi-photo-picker"] && !Shopify.designMode) return;
  try {
    class OpiPhotoOptions extends HTMLElement {
  static maps = new Map();
  async connectedCallback() {
    const url=this.dataset.swatchMap;
    if(!OpiPhotoOptions.maps.has(url)) OpiPhotoOptions.maps.set(url,fetch(url).then(r=>{if(!r.ok)throw new Error('Swatch data unavailable');return r.json();}).catch(()=>({})));
    const map=await OpiPhotoOptions.maps.get(url);
    if(!this.isConnected)return;
    for(const slot of this.querySelectorAll('[data-opi-sku]')) {
      const src=map[slot.dataset.opiSku];
      if(!src || slot.children.length)continue;
      const image=document.createElement('img');image.src=src;image.alt=slot.dataset.opiName;image.width=90;image.height=110;image.loading='lazy';image.decoding='async';image.addEventListener('error',()=>{slot.hidden=true;});slot.append(image);slot.hidden=false;
    }
  }
}
if(!customElements.get('opi-photo-options'))customElements.define('opi-photo-options',OpiPhotoOptions);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-opi-selected-gallery"] && !Shopify.designMode) return;
  try {
    class OpiSelectedGallery extends HTMLElement {
  static maps = new Map();
  connectedCallback() {
    this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
    this.variant=JSON.parse(this.querySelector('[data-current]').textContent);
    this.addEventListener('click',e=>{
      const close=e.target.closest('[data-zoom-close]');
      if(close){this.querySelector('dialog').close();return;}
      const b=e.target.closest('[data-view]');
      if(b){if(b.getAttribute('aria-pressed')==='true'){this.openPhoto(this.querySelector('.ia-opi-reference img'));}else{this.view=b.dataset.view;this.renderReference();}}
      const photo=e.target.closest('.ia-opi-stage img');
      if(photo)this.openPhoto(photo);
    });
    this.setVariant(this.variant);
    const url=this.dataset.mediaMap;
    if(!OpiSelectedGallery.maps.has(url))OpiSelectedGallery.maps.set(url,fetch(url).then(r=>r.ok?r.json():{}).catch(()=>({})));
    OpiSelectedGallery.maps.get(url).then(map=>{if(this.isConnected){this.map=map;this.renderReference();}});
  }
  openPhoto(photo){
    if(!photo?.src)return;
    const dialog=this.querySelector('dialog'),image=dialog.querySelector('img');
    const source=new URL(photo.currentSrc||photo.src,location.href);
    if(source.hostname==='cdn.shopify.com'||source.pathname.startsWith('/cdn/shop/')){source.searchParams.set('width','2000');source.searchParams.delete('height');source.searchParams.delete('crop');}
    image.src=source.href;image.alt=photo.alt;
    dialog.showModal();
  }
  setVariant(variant) {
    if(!variant)return;
    this.variant=variant;this.view=null;
    const img=this.querySelector('.ia-opi-bottle img');
    const src=variant.featured_image?.src || variant.featured_media?.preview_image?.src;
    if(img&&src){img.src=src;img.removeAttribute('srcset');img.alt=variant.title;}
    this.querySelector('[data-gallery-caption]').textContent=variant.title;
    document.querySelectorAll('.breadcrumbs--last').forEach(el=>{el.textContent=this.dataset.productName+' · '+variant.title;});
    const root=this.closest('product-info');
    root?.querySelectorAll('[data-opi-title]').forEach(el=>{el.textContent=variant.title;});
    document.querySelectorAll('sticky-atc-bar .sticky-atc-bar__product-title').forEach(el=>{el.textContent=this.dataset.productName+' · '+variant.title;});
    document.querySelectorAll('sticky-atc-bar .sticky-atc-bar__product-image img').forEach(el=>{if(src){el.src=src;el.removeAttribute('srcset');el.alt=variant.title;}});
    document.title=this.dataset.productName+' · '+variant.title+' – '+this.dataset.shopName;
    this.renderReference();
  }
  renderReference() {
    if(!this.labels)return;
    const entry=this.map?.[this.variant.sku] || {};
    const type=this.view&&entry[this.view]?this.view:entry.mani?'mani':entry.swatch?'swatch':null;
    const figure=this.querySelector('.ia-opi-reference'),tabs=this.querySelector('.ia-opi-reference-tabs');
    figure.hidden=!type;tabs.hidden=!type;
    for(const button of tabs.querySelectorAll('button')){button.hidden=!entry[button.dataset.view];button.setAttribute('aria-pressed',String(type===button.dataset.view));}
    if(!type)return;
    const img=figure.querySelector('img');img.alt=this.variant.title+' — '+this.labels[type];img.src=entry[type];img.onerror=()=>{figure.hidden=true;tabs.hidden=true;};
    figure.querySelector('figcaption').textContent=this.labels[type];
  }
}
if(!customElements.get('opi-selected-gallery'))customElements.define('opi-selected-gallery',OpiSelectedGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-readable-product-images"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ia-readable-product-images')) {
    customElements.define('ia-readable-product-images', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root) return;
        this.scan = () => {
          this.root.querySelectorAll('.ia-readable-description img:not([data-ia-sized])').forEach(img => {
            const prepare = () => {
              if (!img.naturalWidth || img.dataset.iaSized) return;
              img.dataset.iaSized = 'true';
              const width = img.clientWidth;
              const height = img.clientHeight;
              const tall = img.naturalHeight / img.naturalWidth > 1.6 && width > 180;
              if (width <= 520 && height <= 480 && !tall) return;
              if (img.naturalHeight / img.naturalWidth > 2.5 && width > 180 && !img.closest('a')) {
                const details = document.createElement('details');
                details.className = 'ia-poster';
                const summary = document.createElement('summary');
                const preview = img.cloneNode(false);
                preview.removeAttribute('id');
                preview.removeAttribute('style');
                preview.alt = '';
                preview.dataset.iaSized = 'true';
                const label = document.createElement('span');
                label.textContent = this.dataset.expandLabel;
                summary.append(preview, label);
                img.before(details);
                details.append(summary, img);
              } else {
              img.classList.add('ia-image-compact');
              }
              if (img.closest('a')) return;
              const link = document.createElement('a');
              link.className = 'ia-image-full-link';
              link.href = img.currentSrc || img.src;
              link.target = '_blank';
              link.rel = 'noopener';
              link.textContent = this.dataset.enlargeLabel;
              img.after(link);
            };
            if (img.complete) prepare();
            else img.addEventListener('load', prepare, { once: true });
          });
        };
        this.observer = new MutationObserver(this.scan);
        this.observer.observe(this.root, { childList: true, subtree: true });
        requestAnimationFrame(this.scan);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-spa-shopping"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ia-spa-shopping'))customElements.define('ia-spa-shopping',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('[data-spa-card]')];this.brand=this.querySelector('[data-spa-brand]');this.kind=this.querySelector('[data-spa-kind]');this.scent=this.querySelector('[data-spa-scent]');this.status=this.querySelector('[data-spa-status]');this.brand.addEventListener('change',()=>{this.updateScents();this.render();});this.kind.addEventListener('change',()=>this.render());this.scent.addEventListener('change',()=>this.render());this.updateScents();this.render();}
updateScents(){const old=this.scent.value;const scents=[...new Set(this.cards.filter(c=>this.brand.value==='all'||c.dataset.brand===this.brand.value).map(c=>c.dataset.scent).filter(Boolean))].sort();while(this.scent.options.length>1)this.scent.remove(1);for(const scent of scents){const option=document.createElement('option');option.value=scent;option.textContent=scent;this.scent.append(option);}this.scent.value=scents.includes(old)?old:'all';}
render(){let count=0;for(const card of this.cards){const visible=(this.brand.value==='all'||card.dataset.brand===this.brand.value)&&(this.kind.value==='all'||card.dataset.kind===this.kind.value)&&(this.scent.value==='all'||card.dataset.scent===this.scent.value);card.hidden=!visible;if(visible)count++;}this.status.textContent=this.status.dataset.countLabel.replace('[count]',count);this.querySelector('[data-spa-empty]').hidden=count!==0;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-supply-order-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ia-supply-order')) {
  customElements.define('ia-supply-order', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const source = this.querySelector('[data-order-variants]');
      if (!source) return;
      this.ready = true;
      this.variants = JSON.parse(source.textContent);
      this.selects = Array.from(this.querySelectorAll('[data-option-index]'));
      this.form = this.querySelector('form');
      this.idInput = this.form.querySelector('[name="id"]');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.submit = this.form.querySelector('[type="submit"]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.selects.forEach((select, index) => select.addEventListener('change', () => this.updateVariant(index)));
      this.quantity.addEventListener('change', () => this.updateTotal());
      this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
        const step = Number(this.quantity.step) || 1;
        this.quantity.value = String((Number(this.quantity.value) || Number(this.quantity.min) || 1) + Number(button.dataset.quantityStep) * step);
        this.updateTotal();
      }));
      this.form.addEventListener('submit', event => {
        this.updateTotal();
        if (!this.variant?.available || this.idInput.disabled || !this.quantity.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.quantity.reportValidity();
        }
      }, true);
      this.updateVariant();
    }
    updateVariant(changedIndex) {
      let values = this.selects.map(select => select.value);
      let variant = this.selects.length ? this.variants.find(v => v.options.every((value, index) => value === values[index])) : this.variants.find(v => String(v.id) === this.idInput.value);
      if (!variant && changedIndex !== undefined) {
        const compatible = this.variants.filter(v => v.options.slice(0, changedIndex + 1).every((value, index) => value === values[index]));
        variant = compatible.find(v => v.available) || compatible[0];
        if (variant) this.selects.forEach((select, index) => { select.value = variant.options[index]; });
      }
      values = this.selects.map(select => select.value);
      this.selects.forEach((select, index) => {
        Array.from(select.options).forEach(option => {
          option.disabled = !this.variants.some(v => v.options[index] === option.value && v.options.slice(0, index).every((value, i) => value === values[i]));
        });
      });
      this.variant = variant;
      const available = Boolean(variant?.available);
      this.idInput.value = variant ? String(variant.id) : '';
      this.idInput.disabled = !available;
      this.submit.disabled = !available;
      this.querySelector('[data-submit-label]').textContent = variant ? (available ? this.dataset.addLabel : this.dataset.soldLabel) : this.dataset.unavailableLabel;
      this.querySelector('[data-price]').textContent = variant ? this.money.format(variant.price / 100) : this.dataset.unavailableLabel;
      const compare = this.querySelector('[data-compare-price]');
      compare.hidden = !variant || variant.compare <= variant.price;
      if (!compare.hidden) compare.textContent = this.money.format(variant.compare / 100);
      if (variant) {
        this.quantity.min = String(variant.min || 1);
        this.quantity.step = String(variant.step || 1);
        if (variant.max !== null && variant.max !== undefined) this.quantity.max = String(variant.max);
        else this.quantity.removeAttribute('max');
        this.querySelectorAll('[data-product-link]').forEach(link => { link.href = variant.url; });
        const img = this.querySelector('img.ia-supply-order__image');
        if (img && variant.image && changedIndex !== undefined && img.getAttribute('src') !== variant.image) {
          img.removeAttribute('srcset');
          img.src = variant.image;
          img.alt = variant.alt;
        }
      }
      this.updateTotal();
    }
    updateTotal() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      let value = Math.max(min, Number(this.quantity.value) || min);
      value = min + Math.ceil((value - min) / step) * step;
      if (this.quantity.max !== '') {
        const max = Number(this.quantity.max);
        value = Math.min(value, min + Math.floor((max - min) / step) * step);
      }
      this.quantity.value = String(value);
      this.querySelector('[data-quantity-step="-1"]').disabled = value <= min;
      this.querySelector('[data-quantity-step="1"]').disabled = this.quantity.max !== '' && value + step > Number(this.quantity.max);
      this.querySelector('[data-item-total]').textContent = this.variant ? this.dataset.totalLabel + ': ' + this.money.format(this.variant.price * value / 100) : this.dataset.unavailableLabel;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ia-supply-shortcuts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ia-supply-category')) {
  customElements.define('ia-supply-category', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('select').addEventListener('change', event => {
        if (event.target.value) window.location.assign(event.target.value);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
